import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { GetDevicesResponse } from 'generated/openapi';

import {
  getRegisteredDevicesKey,
  getRegisteredDevicesOptions,
} from './getRegisteredDevices.options';

export interface UseGetRegisteredDevicesProps<T = GetDevicesResponse> {
  options?: Omit<
    UseQueryOptions<GetDevicesResponse, unknown, T>,
    'queryKey' | 'queryFn'
  >;
}

export function useGetRegisteredDevices<T = GetDevicesResponse>(
  props: UseGetRegisteredDevicesProps<T> = {},
) {
  const { options } = props;

  return useQuery({
    ...getRegisteredDevicesOptions<T>(),
    ...options,
  });
}

useGetRegisteredDevices.getQueryKey = getRegisteredDevicesKey;
